export const standardIcons = {
  account_circle: { lib: "material-symbols", name: "account_circle" },
  ai_spark2: { lib: "material-symbols", name: "ai_spark2" },
  acute: { lib: "material-symbols", name: "acute" },
  account_balance: { lib: "material-symbols", name: "account_balance" },
  add: { lib: "material-symbols", name: "add" },
  add_card: { lib: "material-symbols", name: "add_card" },
  add_reaction: { lib: "material-symbols", name: "add_reaction" },
  alarm: { lib: "material-symbols", name: "alarm" },
  archive: { lib: "material-symbols", name: "archive" },
  arrow_back: { lib: "material-symbols", name: "arrow_back" },
  arrow_back_ios_new: { lib: "material-symbols", name: "arrow_back_ios_new" },
  arrow_downward: { lib: "material-symbols", name: "arrow_downward" },
  arrow_drop_down: { lib: "material-symbols", name: "arrow_drop_down" },
  arrow_right: { lib: "material-symbols", name: "arrow_right" },
  arrow_forward: { lib: "material-symbols", name: "arrow_forward" },
  arrow_forward_ios: { lib: "material-symbols", name: "arrow_forward_ios" },
  arrow_upward: { lib: "material-symbols", name: "arrow_upward" },
  assignment_ind: { lib: "material-symbols", name: "assignment_ind" },
  article: { lib: "material-symbols", name: "article" },
  badge: { lib: "material-symbols", name: "badge" },
  block: { lib: "material-symbols", name: "block" },
  calendar_month: { lib: "material-symbols", name: "calendar_month" },
  cancel: { lib: "material-symbols", name: "cancel" },
  chat_bubble: { lib: "material-symbols", name: "chat_bubble" },
  check: { lib: "material-symbols", name: "check" },
  chevron_right: { lib: "material-symbols", name: "chevron_right" },
  chevron_left: { lib: "material-symbols", name: "chevron_left" },
  check_circle: { lib: "material-symbols", name: "check_circle" },
  close: { lib: "material-symbols", name: "close" },
  cloud_upload: { lib: "material-symbols", name: "cloud_upload" },
  collapse_all: { lib: "material-symbols", name: "collapse_all" },
  computer: { lib: "material-symbols", name: "computer" },
  content_copy: { lib: "material-symbols", name: "content_copy" },
  credit_card: { lib: "material-symbols", name: "credit_card" },
  delete: { lib: "material-symbols", name: "delete" },
  deployed_code: { lib: "material-symbols", name: "deployed_code" },
  description: { lib: "material-symbols", name: "description" },
  devices: { lib: "material-symbols", name: "devices" },
  directions_car: { lib: "material-symbols", name: "directions_car" },
  do_not_disturb_on: { lib: "material-symbols", name: "do_not_disturb_on" },
  document_scanner: { lib: "material-symbols", name: "document_scanner" },
  download: { lib: "material-symbols", name: "download" },
  drive_file_move: { lib: "material-symbols", name: "drive_file_move" },
  electric_bolt: { lib: "material-symbols", name: "electric_bolt" },
  edit: { lib: "material-symbols", name: "edit" },
  edit_square: { lib: "material-symbols", name: "edit_square" },
  flag: { lib: "material-symbols", name: "flag" },
  emoji_flags: { lib: "material-symbols", name: "emoji_flags" },
  emoji_objects: { lib: "material-symbols", name: "emoji_objects" },
  error: { lib: "material-symbols", name: "error" },
  expand_all: { lib: "material-symbols", name: "expand_all" },
  expand_less: { lib: "material-symbols", name: "expand_less" },
  expand_more: { lib: "material-symbols", name: "expand_more" },
  featured_play_list: { lib: "material-symbols", name: "featured_play_list" },
  fiber_manual_record: {
    lib: "materials-symbols",
    name: "fiber_manual_record",
  },
  fingerprint: { lib: "material-symbols", name: "fingerprint" },
  first_page: { lib: "material-symbols", name: "first_page" },
  flight: { lib: "material-symbols", name: "flight" },
  gavel: { lib: "material-symbols", name: "gavel" },
  group: { lib: "material-symbols", name: "group" },
  help: { lib: "material-symbols", name: "help" },
  hourglass_top: { lib: "material-symbols", name: "hourglass_top" },
  home: { lib: "material-symbols", name: "home" },
  image: { lib: "material-symbols", name: "image" },
  inbox: { lib: "material-symbols", name: "inbox" },
  info: { lib: "material-symbols", name: "info" },
  inventory: { lib: "material-symbols", name: "inventory" },
  inventory_2: { lib: "material-symbols", name: "inventory_2" },
  inventory_2_filled: { lib: "material-symbols", name: "inventory_2" },
  key: { lib: "material-symbols", name: "key" },
  keyboard_arrow_left: { lib: "material-symbols", name: "keyboard_arrow_left" },
  keyboard_arrow_right: {
    lib: "material-symbols",
    name: "keyboard_arrow_right",
  },
  keyboard_double_arrow_right: {
    lib: "material-symbols",
    name: "keyboard_double_arrow_right",
  },
  keyboard_double_arrow_left: {
    lib: "material-symbols",
    name: "keyboard_double_arrow_left",
  },
  language: { lib: "material-symbols", name: "language" },
  last_page: { lib: "material-symbols", name: "last_page" },
  link: { lib: "material-symbols", name: "link" },
  list: { lib: "material-symbols", name: "list" },
  list_alt: { lib: "material-symbols", name: "list_alt" },
  lock: { lib: "material-symbols", name: "lock" },
  lock_open: { lib: "material-symbols", name: "lock_open" },
  logout: { lib: "material-symbols", name: "logout" },
  mail: { lib: "material-symbols", name: "mail" },
  menu: { lib: "material-symbols", name: "menu" },
  more_horiz: { lib: "material-symbols", name: "more_horiz" },
  more_vert: { lib: "material-symbols", name: "more_vert" },
  mystery: { lib: "material-symbols", name: "mystery" },
  notification_important: {
    lib: "material-symbols",
    name: "notification_important",
  },
  notifications: { lib: "material-symbols", name: "notifications" },
  open_in_new: { lib: "material-symbols", name: "open_in_new" },
  outgoing_mail: { lib: "material-symbols", name: "outgoing_mail" },
  overview: { lib: "material-symbols", name: "overview" },
  package_2: { lib: "material-symbols", name: "package_2" },
  pace: { lib: "material-symbols", name: "pace" },
  patient_list: { lib: "material-symbols", name: "patient_list" },
  pause: { lib: "material-symbols", name: "pause" },
  pause_circle: { lib: "material-symbols", name: "pause_circle" },
  pending: { lib: "material-symbols", name: "pending" },
  pending_actions: { lib: "material-symbols", name: "pending_actions" },
  person: { lib: "material-symbols", name: "person" },
  person_add: { lib: "material-symbols", name: "person_add" },
  picture_as_pdf: { lib: "material-symbols", name: "picture_as_pdf" },
  pin_drop: { lib: "material-symbols", name: "pin_drop" },
  policy: { lib: "material-symbols", name: "policy" },
  qr_code_2: { lib: "material-symbols", name: "qr_code_2" },
  qr_code_scanner: { lib: "material-symbols", name: "qr_code_scanner" },
  quick_reference_all: { lib: "material-symbols", name: "quick_reference_all" },
  radio_button_checked: {
    lib: "material-symbols",
    name: "radio_button_checked",
  },
  radio_button_unchecked: {
    lib: "material-symbols",
    name: "radio_button_unchecked",
  },
  receipt_long: { lib: "material-symbols", name: "receipt_long" },
  recent_actors: { lib: "material-symbols", name: "recent_actors" },
  redeem: { lib: "material-symbols", name: "redeem" },
  redo: { lib: "material-symbols", name: "redo" },
  remove: { lib: "material-symbols", name: "remove" },
  resume: { lib: "material-symbols", name: "resume" },
  schedule: { lib: "material-symbols", name: "schedule" },
  school: { lib: "material-symbols", name: "school" },
  screen_lock_portrait: {
    lib: "material-symbols",
    name: "screen_lock_portrait",
  },
  search: { lib: "material-symbols", name: "search" },
  send: { lib: "material-symbols", name: "send" },
  send_to_mobile: { lib: "material-symbols", name: "send_to_mobile" },
  sentiment_dissatisfied: {
    lib: "material-symbols",
    name: "sentiment_dissatisfied",
  },
  settings: { lib: "material-symbols", name: "settings" },
  shield_radar: { lib: "material-symbols", name: "shield_radar" },
  show_chart: { lib: "material-symbols", name: "show_chart" },
  shopping_mode: { lib: "material-symbols", name: "shoppingmode" },
  smartphone: { lib: "material-symbols", name: "smartphone" },
  star: { lib: "material-symbols", name: "star" },
  sticky_note_2: { lib: "material-symbols", name: "sticky_note_2" },
  task: { lib: "material-symbols", name: "task" },
  task_alt: { lib: "material-symbols", name: "task_alt" },
  text_ad: { lib: "material-symbols", name: "text_ad" },
  travel_explore: { lib: "material-symbols", name: "travel_explore" },
  verified: { lib: "material-symbols", name: "verified" },
  verified_user: { lib: "material-symbols", name: "verified_user" },
  visibility: { lib: "material-symbols", name: "visibility" },
  visibility_off: { lib: "material-symbols", name: "visibility_off" },
  warning: { lib: "material-symbols", name: "warning" },
  workspaces: { lib: "material-symbols", name: "workspaces" },
  undo: { lib: "material-symbols", name: "undo" },
  attachment: { lib: "material-symbols", name: "attachment" },
};

export const miniIcons = {
  add: { lib: "material-symbols", name: "add" },
  airplanemode_active: { lib: "material-symbols", name: "airplanemode_active" },
  archive: { lib: "material-symbols", name: "archive" },
  arrow_back: { lib: "material-symbols", name: "arrow_back" },
  arrow_downward: { lib: "material-symbols", name: "arrow_downward" },
  arrow_drop_down: { lib: "material-symbols", name: "arrow_drop_down" },
  arrow_right: { lib: "material-symbols", name: "arrow_right" },
  arrow_forward: { lib: "material-symbols", name: "arrow_forward" },
  arrow_upward: { lib: "material-symbols", name: "arrow_upward" },
  assignment: { lib: "material-symbols", name: "assignment" },
  assignment_turned_in: {
    lib: "material-symbols",
    name: "assignment_turned_in",
  },
  auto_renew: { lib: "material-symbols", name: "autorenew" },
  calendar_month: { lib: "material-symbols", name: "calendar_month" },
  calendar_today: { lib: "material-symbols", name: "calendar_today" },
  cancel: { lib: "material-symbols", name: "cancel" },
  check: { lib: "material-symbols", name: "check" },
  check_circle: { lib: "material-symbols", name: "check_circle" },
  checklist: { lib: "material-symbols", name: "checklist" },
  chevron_left: { lib: "material-symbols", name: "chevron_left" },
  chevron_right: { lib: "material-symbols", name: "chevron_right" },
  close: { lib: "material-symbols", name: "close" },
  content_copy: { lib: "material-symbols", name: "content_copy" },
  content_paste: { lib: "material-symbols", name: "content_paste" },
  content_paste_off: { lib: "material-symbols", name: "content_paste_off" },
  "currency-dollar": { lib: "material-symbols", name: "attach_money" },
  currency_pound: { lib: "material-symbols", name: "currency_pound" },
  delete: { lib: "material-symbols", name: "delete" },
  deployed_code: { lib: "material-symbols", name: "deployed_code" },
  directions_car: { lib: "material-symbols", name: "directions_car" },
  document_scanner: { lib: "material-symbols", name: "document_scanner" },
  electric_bolt: { lib: "material-symbols", name: "electric_bolt" },
  edit: { lib: "material-symbols", name: "edit" },
  edit_square: { lib: "material-symbols", name: "edit_square" },
  error: { lib: "material-symbols", name: "error" },
  euro_symbol: { lib: "material-symbols", name: "euro_symbol" },
  emoji_flags: { lib: "material-symbols", name: "emoji_flags" },
  expand_less: { lib: "material-symbols", name: "expand_less" },
  expand_more: { lib: "material-symbols", name: "expand_more" },
  fact_check: { lib: "material-symbols", name: "fact_check" },
  file_download_done: { lib: "material-symbols", name: "file_download_done" },
  download: { lib: "material-symbols", name: "download" },
  first_page: { lib: "material-symbols", name: "first_page" },
  format_list_bulleted: {
    lib: "material-symbols",
    name: "format_list_bulleted",
  },
  frame_person: { lib: "material-symbols", name: "frame_person" },
  help: { lib: "material-symbols", name: "help" },
  hourglass_top: { lib: "material-symbols", name: "hourglass_top" },
  home: { lib: "material-symbols", name: "home" },
  inbox: { lib: "material-symbols", name: "inbox" },
  info: { lib: "material-symbols", name: "info" },
  inventory_2: { lib: "material-symbols", name: "inventory_2" },
  language: { lib: "material-symbols", name: "language" },
  last_page: { lib: "material-symbols", name: "last_page" },
  list: { lib: "material-symbols", name: "list" },
  link: { lib: "material-symbols", name: "link" },
  lock: { lib: "material-symbols", name: "lock" },
  lock_open: { lib: "material-symbols", name: "lock_open" },
  mail: { lib: "material-symbols", name: "mail" },
  more_horiz: { lib: "material-symbols", name: "more_horiz" },
  more_vert: { lib: "material-symbols", name: "more_vert" },
  new_releases: { lib: "material-symbols", name: "new_releases" },
  notification_important: {
    lib: "material-symbols",
    name: "notification_important",
  },
  open_in_new: { lib: "material-symbols", name: "open_in_new" },
  outgoing_mail: { lib: "material-symbols", name: "outgoing_mail" },
  overview: { lib: "material-symbols", name: "overview" },
  package_2: { lib: "material-symbols", name: "package_2" },
  pace: { lib: "material-symbols", name: "pace" },
  pending: { lib: "material-symbols", name: "pending" },
  pending_actions: { lib: "material-symbols", name: "pending_actions" },
  person: { lib: "material-symbols", name: "person" },
  photo_camera: { lib: "material-symbols", name: "photo_camera" },
  picture_as_pdf: { lib: "material-symbols", name: "picture_as_pdf" },
  qr_code_2: { lib: "material-symbols", name: "qr_code_2" },
  qr_code_scanner: { lib: "material-symbols", name: "qr_code_scanner" },
  receipt_long: { lib: "material-symbols", name: "receipt_long" },
  redeem: { lib: "material-symbols", name: "redeem" },
  redo: { lib: "material-symbols", name: "redo" },
  remove: { lib: "material-symbols", name: "remove" },
  resume: { lib: "material-symbols", name: "resume" },
  rule: { lib: "material-symbols", name: "rule" },
  schedule: { lib: "material-symbols", name: "schedule" },
  shopping_mode: { lib: "material-symbols", name: "shoppingmode" },
  school: { lib: "material-symbols", name: "school" },
  search: { lib: "material-symbols", name: "search" },
  send: { lib: "material-symbols", name: "send" },
  settings: { lib: "material-symbols", name: "settings" },
  shield_radar: { lib: "material-symbols", name: "shield_radar" },
  smartphone: { lib: "material-symbols", name: "smartphone" },
  swap_vert: { lib: "material-symbols", name: "swap_vert" },
  task: { lib: "material-symbols", name: "task" },
  task_alt: { lib: "material-symbols", name: "task_alt" },
  unfold_less: { lib: "material-symbols", name: "unfold_less" },
  unfold_more: { lib: "material-symbols", name: "unfold_more" },
  upload: { lib: "material-symbols", name: "upload" },
  upload_file: { lib: "material-symbols", name: "upload_file" },
  verified_user: { lib: "material-symbols", name: "verified_user" },
  visibility: { lib: "material-symbols", name: "visibility" },
  visibility_off: { lib: "material-symbols", name: "visibility_off" },
  warning: { lib: "material-symbols", name: "warning" },
  workspaces: { lib: "material-symbols", name: "workspaces" },
  attachment: { lib: "material-symbols", name: "attachment" },
};

export const customIcons = {
  "user-profile-circle": { lib: "custom", name: "user-profile-circle" },
  "my-certn-app": { lib: "custom", name: "my-certn-app" },
  select: { lib: "custom", name: "select" },
  bullet: { lib: "custom", name: "bullet" },
  google: { lib: "custom", name: "google" },
  apple: { lib: "custom", name: "apple" },
  linkedin: { lib: "custom", name: "linkedin" },
  sparkles: { lib: "custom", name: "sparkles" },
  sparkles_v2: { lib: "custom", name: "sparkles_v2" },
  ai_spark: { lib: "custom", name: "ai_spark" },
  ai_gen_text: { lib: "custom", name: "ai_gen_text" },
};

export type CascadiaStandardIcon = keyof typeof standardIcons;
export type CascadiaMiniIcon = keyof typeof miniIcons;
export type CascadiaCustomIcon = keyof typeof customIcons;

export type CascadiaIcon =
  | CascadiaStandardIcon
  | CascadiaMiniIcon
  | CascadiaCustomIcon;
